import classNames from "classnames";

export const VERSION = "1.0.0";
export const USE_SUPERTOKENS = process.env.REACT_APP_USE_SUPERTOKENS === 'true';

export const platform = () => {
  return process.env.REACT_APP_ENV;
}

export const formStyles = {
  error: (error) =>
    classNames("input", {
      "border-negative-red border-opacity-50": error,
    }),
  input: (error) =>
    classNames("mb-3 w-full", {
      "mb-5": error,
    }),
  validation:
    "text-negative-red mt-1 text-xs",
};

// eslint-disable-next-line
export const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
